import React, { Suspense } from 'react';
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { ConfigProvider, App as AntApp } from 'antd';
import { history } from './utils/history';

function shouldForwardProp(propName, target) {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
}

import 'antd/dist/reset.css';
import './App.css';

import ContentComponent from './content';
import LoginComponent from './auth';
import ResetPasswordComponent from "./auth/ResetPasswordComponent";

//Theming fonts
import fontTheme from './utils/fontTheme';
import GlobalStyles from './utils/GlobalStyles';
import VerificationOTP from './auth/VerificationOTP';
import { useVersionUpdater } from './hooks/useVersionUpdater';
import { AuthenticatedSessionProvider, useAuthentication } from './context/AuthProvider';
import authorization from './auth/authorization';
import config from './config';
import { antdTheme } from './theme/antdTheme';

function App() {
  const { accessToken } = useAuthentication();
  useVersionUpdater();

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ConfigProvider theme={antdTheme}>
        <AntApp component={false}>
          <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID || ''}>
            <ThemeProvider theme={fontTheme}>
              <Router history={history}>
                <Suspense fallback="loading">
                  <Switch>
                    <Route
                      exact
                      path="/login"
                      render={() => {
                        if (accessToken) return <Redirect to="/report-charts" />;
                        return <LoginComponent />;
                      }}
                    />
                    <Route
                      exact
                      path="/verify-otp/:userId"
                      render={(() => {
                        if (accessToken) return <Redirect to="/report-charts" />;
                        return <VerificationOTP />
                      })}
                    />
                    <Route
                      exact
                      path="/reset-password"
                      render={() => {
                        if (accessToken) return <Redirect to="/report-charts" />;
                        return <ResetPasswordComponent />;
                      }}
                    />
                    <Route
                      path="/*"
                      render={(props) => {
                        if (accessToken) return (
                          <AuthenticatedSessionProvider>
                            <ContentComponent userDetails={authorization.getUserDetails()} {...props} />
                          </AuthenticatedSessionProvider>
                        )
                        return <Redirect to='/login' {...props} />;
                      }}
                    />
                  </Switch>
                </Suspense>
              </Router>
              <GlobalStyles />
            </ThemeProvider>
          </GoogleOAuthProvider>
        </AntApp>
      </ConfigProvider>
    </StyleSheetManager>
  )
}

export default App;
